export default function MainFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className='main-footer'>© {currentYear} CCL Software, LLC. All Rights Reserved.</footer>
  )
}
